import { render, staticRenderFns } from "./ProjectsRequestsHeader.vue?vue&type=template&id=43538feb&scoped=true"
import script from "./ProjectsRequestsHeader.vue?vue&type=script&lang=js"
export * from "./ProjectsRequestsHeader.vue?vue&type=script&lang=js"
import style0 from "./ProjectsRequestsHeader.vue?vue&type=style&index=0&id=43538feb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43538feb",
  null
  
)

export default component.exports